import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { RadioGroup, FieldRadio } from 'cstar-react-primitives';
import { cashbotName } from '../core/coreUtils';



export const DenomPicker = ({
    field: {
        name
    },
    legend,
    denominations,
    value,
    formatValue,
    handleChange
}) => {
    const containerProps = {
        legend,
        cashbotName,
        className: classNames(
            'denom-picker',
            { 'one-choice': (denominations.length === 1) }
        ),
        name
    };

    return (
        <RadioGroup {...containerProps}>
            { denominations.map((denom) => (
                <FieldRadio
                    name={name}
                    key={denom}
                    val={denom}
                    isChecked={denom === value}
                    cssClass="denom-option"
                    handleChange={handleChange}
                >
                    { formatValue(denom) }
                </FieldRadio>
            )) }
        </RadioGroup>
    );
};

DenomPicker.propTypes = {
    field: PropTypes.shape({
        name: PropTypes.string.isRequired
    }).isRequired,
    legend: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    denominations: PropTypes.array.isRequired,
    formatValue: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired
};

export default DenomPicker;
